var _excluded = ["appendIcon", "autoComplete", "autoFocus", "className", "clearable", "disabled", "hint", "label", "max", "maxLength", "min", "name", "onBlur", "onChange", "onClear", "onClick", "onClickAppend", "onClickPrepend", "onFocus", "onKeyUp", "onPaste", "placeholder", "prependIcon", "readOnly", "required", "rules", "spinner", "step", "type", "validateOnBlur", "validationState", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { ATooltipPropTypes } from "../ATooltip";
import AInputBase from "../AInputBase";
import { AFormContext } from "../AForm";
import AIcon from "../AIcon";
import { useCombinedRefs } from "../../utils/hooks";
import { keyCodes } from "../../utils/helpers";
import "./ATextInput.scss";
var chevronDown = "M15.787 4.837a.686.686 0 000-.994.744.744 0 00-1.029 0L8 10.376 1.24 3.843a.744.744 0 00-1.028 0 .69.69 0 000 .994L8 12.364l7.787-7.527z";
var chevronUp = "M.213 11.163a.686.686 0 000 .995.744.744 0 001.029 0L8 5.624l6.759 6.534a.744.744 0 001.028 0 .69.69 0 000-.995L8 3.636.213 11.163z";
var textInputCounter = 0;
var ATextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var appendIcon = _ref.appendIcon,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    propsClassName = _ref.className,
    clearable = _ref.clearable,
    disabled = _ref.disabled,
    hint = _ref.hint,
    label = _ref.label,
    max = _ref.max,
    maxLength = _ref.maxLength,
    min = _ref.min,
    name = _ref.name,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    _onClear = _ref.onClear,
    onClick = _ref.onClick,
    onClickAppend = _ref.onClickAppend,
    onClickPrepend = _ref.onClickPrepend,
    _onFocus = _ref.onFocus,
    onKeyUp = _ref.onKeyUp,
    onPaste = _ref.onPaste,
    placeholder = _ref.placeholder,
    prependIcon = _ref.prependIcon,
    readOnly = _ref.readOnly,
    required = _ref.required,
    rules = _ref.rules,
    _ref$spinner = _ref.spinner,
    spinner = _ref$spinner === void 0 ? true : _ref$spinner,
    step = _ref.step,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "text" : _ref$type,
    validateOnBlur = _ref.validateOnBlur,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var textInputRef = useRef(null);
  var _useState = useState(textInputCounter++),
    _useState2 = _slicedToArray(_useState, 1),
    textInputId = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    longClickTimeout = _useState6[0],
    setLongClickTimeout = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    longClickInterval = _useState8[0],
    setLongClickInterval = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useState11 = useState(validationState),
    _useState12 = _slicedToArray(_useState11, 2),
    workingValidationState = _useState12[0],
    setWorkingValidationState = _useState12[1];
  var combinedRef = useCombinedRefs(ref, textInputRef);
  useEffect(function () {
    if (!autoFocus || typeof document === "undefined" || !combinedRef || !combinedRef.current || document.activeElement === combinedRef.current.querySelector(".a-text-input__input")) return;
    combinedRef.current.querySelector(".a-text-input__input").focus();
  }, [autoFocus, combinedRef]);
  var _useContext = useContext(AFormContext),
    register = _useContext.register,
    unregister = _useContext.unregister;
  useEffect(function () {
    setWorkingValidationState(validationState);
  }, [validationState]);
  useEffect(function () {
    if (register) {
      register("a-text-input_".concat(textInputId), {
        reset: reset,
        validate: validate
      });
    }
  }, [validationState, value, rules]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (unregister) {
      return function () {
        return unregister("a-text-input_".concat(textInputId));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var prependProps = {
    className: "a-text-input__prepend-icon"
  };
  if (!disabled && !readOnly && onClickPrepend) {
    prependProps.className += " interactable";
    prependProps.onClick = onClickPrepend;
    prependProps.onKeyDown = function (e) {
      if (onClickPrepend && [keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
        e.preventDefault();
        onClickPrepend(e);
      }
    };
    prependProps.tabIndex = 0;
    prependProps.role = "button";
  }
  var appendProps = {
    className: "a-text-input__append-icon",
    key: "a-text-input__append-icon"
  };
  if (!disabled && !readOnly && onClickAppend) {
    appendProps.className += " interactable";
    appendProps.onClick = onClickAppend;
    appendProps.onKeyDown = function (e) {
      if (onClickAppend && [keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
        e.preventDefault();
        onClickAppend(e);
      }
    };
    appendProps.tabIndex = 0;
    appendProps.role = "button";
  }
  var appendContent = [];
  var isNumberType = type === "number";
  var incrementInput = function incrementInput() {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : step || 1;
    var input = combinedRef.current.querySelector(".a-text-input__input");
    var nativeInputValueGetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").get;
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
    var currentValue = parseFloat(nativeInputValueGetter.call(input));
    var finalValue = 0;
    if (!isNaN(currentValue)) {
      if (typeof min !== "undefined" && currentValue < min && Math.abs(currentValue + amount) < Math.abs(currentValue)) {
        finalValue = min;
      } else if (typeof max !== "undefined" && currentValue > max && Math.abs(currentValue + amount) < Math.abs(currentValue)) {
        finalValue = max;
      } else {
        finalValue = Math.ceil(currentValue / amount) * amount;
        if (finalValue === currentValue) finalValue += amount;
        if (typeof min !== "undefined" && finalValue < min || typeof max !== "undefined" && finalValue > max) {
          finalValue = currentValue;
        }
      }
    } else {
      finalValue = amount;
    }
    nativeInputValueSetter.call(input, finalValue);
    var event = new Event("input", {
      bubbles: true
    });
    input.dispatchEvent(event);
  };
  if (isNumberType && !disabled && !readOnly && spinner) {
    appendContent.push( /*#__PURE__*/React.createElement("div", {
      key: "a-text-input__spinner",
      className: "a-text-input__spinner"
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      className: "a-text-input__spinner__up",
      onMouseLeave: function onMouseLeave() {
        clearTimeout(longClickTimeout);
        clearInterval(longClickInterval);
      },
      onMouseUp: function onMouseUp() {
        clearTimeout(longClickTimeout);
        clearInterval(longClickInterval);
      },
      onMouseDown: function onMouseDown() {
        setLongClickTimeout(setTimeout(function () {
          setLongClickInterval(setInterval(function () {
            incrementInput();
          }, 33));
        }, 300));
        incrementInput();
      }
    }, /*#__PURE__*/React.createElement("path", {
      d: chevronUp
    })), /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      className: "a-text-input__spinner__down",
      onMouseLeave: function onMouseLeave() {
        clearTimeout(longClickTimeout);
        clearInterval(longClickInterval);
      },
      onMouseUp: function onMouseUp() {
        clearTimeout(longClickTimeout);
        clearInterval(longClickInterval);
      },
      onMouseDown: function onMouseDown() {
        setLongClickTimeout(setTimeout(function () {
          setLongClickInterval(setInterval(function () {
            incrementInput(-1 * (step || 1));
          }, 33));
        }, 300));
        incrementInput(-1 * (step || 1));
      }
    }, /*#__PURE__*/React.createElement("path", {
      d: chevronDown
    }))));
  }
  if (appendIcon) {
    appendContent.push( /*#__PURE__*/React.createElement(AIcon, appendProps, appendIcon));
  }
  var validate = function validate() {
    var testValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : value;
    if (rules || required || typeof min !== "undefined" || typeof max !== "undefined") {
      var workingRules = [];
      if (rules) {
        workingRules = _toConsumableArray(rules);
      }
      if (typeof max !== "undefined") {
        workingRules = [{
          test: function test(v) {
            return v <= max || "".concat(label ? label + " has a m" : "M", "aximum value of ").concat(max);
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      if (typeof min !== "undefined") {
        workingRules = [{
          test: function test(v) {
            return v >= min || "".concat(label ? label + " has a m" : "M", "inimum value of ").concat(min);
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      if (required) {
        workingRules = [{
          test: function test(v) {
            return !!v || "".concat(label ? label + " is r" : "R", "equired");
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      setWorkingValidationState("default");
      setError(null);
      for (var i = 0; i < workingRules.length; i++) {
        var _error = workingRules[i].test(testValue);
        if (_error !== true) {
          setError(_error);
          setWorkingValidationState(workingRules[i].level || "danger");
          return {
            message: _error,
            level: workingRules[i].level || "danger"
          };
        }
      }
    }
  };
  var reset = function reset() {
    setWorkingValidationState(validationState);
    setError("");
  };
  var inputBaseProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: combinedRef,
    className: "a-text-input",
    clearable: clearable,
    error: error,
    hint: hint,
    label: label,
    required: required,
    labelFor: "a-text-input_".concat(textInputId),
    disabled: disabled,
    focused: isFocused,
    append: appendContent,
    prepend: prependIcon && /*#__PURE__*/React.createElement(AIcon, prependProps, prependIcon),
    readOnly: readOnly,
    validationState: workingValidationState,
    onClear: function onClear() {
      var e = combinedRef.current.querySelector(".a-text-input__input");
      var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
      nativeInputValueSetter.call(e, "");
      var event = new Event("input", {
        bubbles: true
      });
      e.dispatchEvent(event);
      reset();
      _onClear && _onClear(e);
    }
  });
  if (isNumberType) {
    inputBaseProps.className += " a-text-input--type-number";
  }
  if (propsClassName) {
    inputBaseProps.className += " ".concat(propsClassName);
  }
  var inputProps = {
    autoComplete: autoComplete,
    className: "a-text-input__input",
    disabled: disabled,
    id: "a-text-input_".concat(textInputId),
    max: max,
    maxLength: maxLength,
    min: min,
    name: name,
    onBlur: function onBlur(e) {
      setIsFocused(false);
      validate(e.target.value);
      _onBlur && _onBlur(e);
    },
    onChange: function onChange(e) {
      !validateOnBlur && validate(e.target.value);
      _onChange && _onChange(e);
    },
    onClick: onClick,
    onFocus: function onFocus(e) {
      setIsFocused(true);
      _onFocus && _onFocus(e);
    },
    onKeyUp: onKeyUp,
    onPaste: onPaste,
    placeholder: placeholder,
    readOnly: readOnly,
    step: step,
    type: type,
    value: value
  };
  return /*#__PURE__*/React.createElement(AInputBase, inputBaseProps, /*#__PURE__*/React.createElement("input", inputProps));
});
var anchorRef = ATooltipPropTypes.anchorRef,
  infoTooltipProps = _objectWithoutProperties(ATooltipPropTypes, ["anchorRef"]);
ATextInput.propTypes = {
  /**
   * Appends an icon inside the text input. The value should be an [icon name](/components/icon).
   */
  appendIcon: PropTypes.string,
  /**
   * The input's `autocomplete` attribute.
   */
  autoComplete: PropTypes.string,
  /**
   * Toggles whether the input auto-focuses on mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Toggles whether to display a clearable icon.
   */
  clearable: PropTypes.bool,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * Adds an information tooltip next to the label
   */
  infoTooltip: PropTypes.string,
  /**
   * Overrides props of `ATooltip` used to display `infoTooltip`. See `ATooltip.propTypes`.
   */
  infoTooltipProps: PropTypes.shape(infoTooltipProps),
  /**
   * Sets the maximum value of a number type text input.
   */
  max: PropTypes.number,
  /**
   * Sets the maximum length of the text input value.
   */
  maxLength: PropTypes.number,
  /**
   * Sets the minimum value of a number type text input.
   */
  min: PropTypes.number,
  /**
   * The input's `name` attribute.
   */
  name: PropTypes.string,
  /**
   * Handles the `blur` event
   */
  onBlur: PropTypes.func,
  /**
   * Handles the `change` event.
   */
  onChange: PropTypes.func,
  /**
   * Handles the `clear` event (for supplemental handling).
   */
  onClear: PropTypes.func,
  /**
   * Handles the `click` event for the input.
   */
  onClick: PropTypes.func,
  /**
   * Handles the `click` event for an appended icon.
   */
  onClickAppend: PropTypes.func,
  /**
   * Handles the `click` event for a prepended icon.
   */
  onClickPrepend: PropTypes.func,
  /**
   * Handles the `focus` event.
   */
  onFocus: PropTypes.func,
  /**
   * Handles the `keyUp` event.
   */
  onKeyUp: PropTypes.func,
  /**
   * Handles the `paste` event.
   */
  onPaste: PropTypes.func,
  /**
   * The input's `placeholder` attribute.
   */
  placeholder: PropTypes.string,
  /**
   * Prepends an icon inside the text input. The value should be an [icon name](/components/icon).
   */
  prependIcon: PropTypes.string,
  /**
   * Toggles the `readOnly` state.
   */
  readOnly: PropTypes.bool,
  /**
   * Toggles a default rule for required values.
   */
  required: PropTypes.bool,
  /**
   * Sets validation rules for the component.
   */
  rules: PropTypes.arrayOf(PropTypes.shape({
    test: PropTypes.func,
    level: PropTypes.string
  })),
  /**
   * Toggles the spinner for number type inputs.
   */
  spinner: PropTypes.bool,
  /**
   * Sets the increment/decrement value for number type text inputs.
   */
  step: PropTypes.number,
  /**
   * Change the input type to take advantage of native behavior.
   */
  type: PropTypes.oneOf(["text", "password", "email", "number"]),
  /**
   * Delays validation until the `blur` event.
   */
  validateOnBlur: PropTypes.bool,
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /**
   * The input's `value` attribute.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ATextInput.displayName = "ATextInput";
export default ATextInput;